import React from 'react';
import Heading from "../elements/Heading";
import PlainText from "../modules/PlainText";
import charges from "../../../data/mobile-fleet/charges.json";

const MobileCharges = () => {

    return (
        <div className="mobile-charges">
            <div className="row">
                <div className="col-12 col-lg-8 col-lg-offset-2">
                    <Heading title={charges.title} className="text-center mb-0">
                        <p dangerouslySetInnerHTML={{__html: charges.description}} />
                    </Heading>
                </div>
            </div>
            <div className="row pb-5 mt-3">
                <div className="col-12 col-lg-8 col-lg-offset-1">
                    <h4 className="mt-0 bold text-center">{charges.titleAll}</h4>
                    {charges.allCharges.map((item, key) => {
                        return <PlainText key={key} data={item} excludeTitle={true} />;
                    })}
                </div>
            </div>
        </div>
    );

}

export default MobileCharges;


// WEBPACK FOOTER //
// ./resources/assets/js/mobileFleet/MobileCharges.js